import { useContext, useEffect, useRef, useState } from "react";
import { MyContext } from "../../App";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import Rating from "@mui/material/Rating";
import Skeleton from "@mui/material/Skeleton";
import { fetchDataFromApi, postData } from "../../utils/api";
import { TfiFullscreen } from "react-icons/tfi";
import { FaHeart, FaAngleDown } from "react-icons/fa";
import { IoMdHeartEmpty, IoIosImages } from "react-icons/io";
import Slider from "react-slick";
import ProductModal from "./ProductModal";
import { FaShoppingCart } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  toggleWishlistItem,
  fetchWishlistItems,
} from "../../store/slices/WishlistSlice";

const ProductItem = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [optimisticWishlistState, setOptimisticWishlistState] = useState(null);
  const dispatch = useDispatch();
  const { wishlistItems } = useSelector((state) => state.wishlist);

  const isAddedToMyList =
    optimisticWishlistState !== null
      ? optimisticWishlistState
      : wishlistItems &&
        wishlistItems.some((item) => item.productId?._id === props.item?._id);

  let avgDiscount = 0;
  if (props.item.prices && props.item.prices.length > 0) {
    const totalDiscount = props.item.prices.reduce(
      (acc, price) => acc + (price.discount || 0),
      0
    );
    avgDiscount = Math.ceil(totalDiscount / props.item.prices.length);
  }

  const context = useContext(MyContext);
  const sliderRef = useRef();

  const settings = {
    dots: true,
    infinite: true,
    loop: true,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: 100,
  };

  const viewProductDetails = (id) => {
    context.openProductDetailsModal(id, true);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
    setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickPlay();
      }
    }, 20);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickPause();
      }
    }, 20);
  };

  // Reset optimistic state when wishlistItems change
  useEffect(() => {
    setOptimisticWishlistState(null);
  }, [wishlistItems]);

  const handleToggleWishlist = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Please login to continue",
      });
      return;
    }

    // Optimistically update UI
    const newState = !isAddedToMyList;
    setOptimisticWishlistState(newState);

    try {
      await dispatch(toggleWishlistItem(props.item._id)).unwrap();
      const user = JSON.parse(localStorage.getItem("user"));
      dispatch(fetchWishlistItems(user._id));
    } catch (error) {
      // Revert optimistic update on error
      setOptimisticWishlistState(!newState);
      context.setAlertBox({
        open: true,
        error: true,
        msg: error || "Failed to update wishlist",
      });
    }
  };

  if (!props.item) {
    return (
      <div className={`productItem ${props.itemView} h-[400px] w-[250px]`}>
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </div>
    );
  }

  return (
    <>
      <div
        className={`productItem ${props.itemView} h-[400px] w-[250px]`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="img_rapper">
          <Link
            to={`/product/${
              props?.itemView === "recentlyView"
                ? props.item?.prodId
                : props.item?._id
            }`}
          >
            <div className="productItemSliderWrapper">
              <img src={props.item?.images[0]} className="w-100 img1" />
              {props.item?.images?.length > 1 && (
                <img src={props.item?.images[1]} className="w-100 img2" />
              )}
            </div>
          </Link>
          <span className="badge badge-primary">
            {Math.ceil(props.item?.prices[0]?.discount)}%
          </span>

          <div className="actions">
            <Button onClick={() => setIsModalOpen(true)}>
              <TfiFullscreen />
            </Button>
            <Button
              className={`wishlist_btn ${isAddedToMyList ? "active" : ""}`}
              onClick={handleToggleWishlist}
              style={{
                transition: "all 0.3s ease",
                transform: isAddedToMyList ? "scale(1.1)" : "scale(1)",
              }}
            >
              {isAddedToMyList ? (
                <FaHeart style={{ fontSize: "20px", color: "#ff4757" }} />
              ) : (
                <IoMdHeartEmpty style={{ fontSize: "20px" }} />
              )}
            </Button>
          </div>
        </div>

        <div className="info" title={props?.item?.name}>
          <Link
            to={`/product/${
              props?.itemView === "recentlyView"
                ? props.item?.prodId
                : props.item?._id
            }`}
          >
            <h4>{props?.item?.name?.substr(0, 20) + "..."}</h4>
          </Link>

          {props?.item?.prices[0]?.countInStock >= 1 ? (
            <span className="text-success d-block">In Stock</span>
          ) : (
            <span className="text-danger d-block">Out of Stock</span>
          )}

          <Rating
            className="mt-2 mb-2"
            name="read-only"
            value={props?.item?.rating}
            readOnly
            size="small"
            precision={0.5}
          />

          <div>
            <div>
              <span className="oldPrice">
                ₹ {props?.item?.prices[0]?.oldPrice}
              </span>

              <span className="netPrice text-black ml-2">
                ₹ {props?.item?.prices[0]?.actualPrice}
              </span>
            </div>

            <span className="text-[16px] hidden md:inline">Size</span>
            <button
              onClick={() => setIsModalOpen(true)}
              className="px-3 py-1 bg-white text-black border rounded-md  hover:bg-blue-600 mt-2 ml-2"
            >
              <span className="p-1 flex md:me-2 me-[-10px] text-xs  md:text-sm">
                {props?.item?.prices[0]?.quantity}&nbsp;
                {props?.item?.prices[0]?.type}
                <FaAngleDown size={20} color="black" className="ms-6" />
              </span>
            </button>
          </div>
        </div>
      </div>
      <ProductModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        product={props.item}
      />
    </>
  );
};

export default ProductItem;
